import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import "../HomeScreen.css";
import "./Hotels.css";
import Navbar from "../Navbar";
import Footer from "../Footer";

const MICE = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    eventType: "Conference",
    destination: "",
    startDate: "",
    endDate: "",
    attendees: "10",
    requirements: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await addDoc(collection(db, "enquiry"), {
        ...form,
        enquiryType: "mice booking",
        createdAt: serverTimestamp(),
      });
      setStatus("success");
      setForm({
        name: "", email: "", phone: "", companyName: "", eventType: "Conference",
        destination: "", startDate: "", endDate: "", attendees: "10", requirements: "",
      });
      setTimeout(() => setStatus(null), 4000);
    } catch (err) {
      console.error("Error submitting MICE enquiry: ", err);
      setStatus("error");
    }
  };

  // Industries We Serve Data
  const industriesWeServe = [
    { name: "IT & Technology", logo: "💻" },
    { name: "Pharmaceuticals", logo: "💊" },
    { name: "Manufacturing", logo: "🏭" },
    { name: "Automobile", logo: "🚗" },
    { name: "Banking & Finance", logo: "🏦" },
    { name: "Healthcare", logo: "🏥" },
    { name: "Education", logo: "🎓" },
    { name: "Telecom", logo: "📡" },
  ];

  // MICE Services Categories
  const miceServices = [
    { icon: "🏢", name: "Meetings", desc: "Board meetings, annual sales meets, dealer meets & product launches." },
    { icon: "✈️", name: "Incentive Travel", desc: "Domestic & international reward trips, team building & leadership retreats." },
    { icon: "🎤", name: "Conferences", desc: "Venue selection, delegate registration, speaker management & AV setup." },
    { icon: "🎪", name: "Exhibitions", desc: "Trade fair participation, booth setup coordination & group flight bookings." },
  ];

  // Why Choose Us Data
  const whyChooseBenefits = [
    { icon: "👥", title: "Dedicated MICE Team", desc: "A specialized team assigned to handle your corporate events end-to-end." },
    { icon: "💰", title: "Competitive Corporate Rates", desc: "Access exclusive deals and negotiated pricing for your business needs." },
    { icon: "🌍", title: "Global Destination Expertise", desc: "Worldwide network of venues, hotels, and DMCs for seamless execution." },
    { icon: "🎧", title: "24x7 Travel Support", desc: "Round-the-clock assistance for your delegates and travelers anywhere." },
    { icon: "📋", title: "End-to-End Event Management", desc: "From concept to execution, we handle logistics, AV, and operations." },
    { icon: "🎯", title: "Customized Corporate Solutions", desc: "Tailored itineraries and events designed to meet your specific objectives." },
  ];

  return (
    <div className="home-container">
      <Navbar />

      {/* Hero Section */}
      <section 
        className="hero-section" 
        style={{ 
          background: "linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.5)), url('https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div className="hero-overlay">
          <h1>
            Corporate Travel & <span style={{
              background: "linear-gradient(135deg, #ff8c00, #ff5500)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}> MICE Solutions </span>
          </h1>
          <p>Seamless Meetings, Incentive Tours, Conferences & Exhibitions Worldwide.</p>
          
          {/* ✨ Beautifully Styled CTA Buttons ✨ */}
          <div style={{
            display: "flex",
            gap: "1.2rem",
            justifyContent: "center",
            flexWrap: "wrap",
            marginTop: "2.5rem"
          }}>
            {/* 1. Request a Proposal (Primary White) */}
            <button 
              onClick={() => document.getElementById('mice-form').scrollIntoView({ behavior: 'smooth' })}
              style={{
                padding: "14px 32px",
                borderRadius: "50px",
                fontWeight: "700",
                fontSize: "1rem",
                cursor: "pointer",
                border: "none",
                background: "white",
                color: "#0f5e6e",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                transition: "all 0.3s",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px"
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
              onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
            >
              📝 Request a Proposal
            </button>

            {/* 2. Get a Quote (WhatsApp Green Gradient) */}
            <button 
              onClick={() => window.open('https://wa.me/919096785868?text=Hi! I want to get a quote for MICE services.', '_blank')}
              style={{
                padding: "14px 32px",
                borderRadius: "50px",
                fontWeight: "700",
                fontSize: "1rem",
                cursor: "pointer",
                border: "none",
                background: "linear-gradient(135deg, #25D366, #128c7e)",
                color: "white",
                boxShadow: "0 8px 20px rgba(37, 211, 102, 0.3)",
                transition: "all 0.3s",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px"
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-3px)"}
              onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
            >
              💬 Get a Quote
            </button>

            {/* 3. Contact MICE Team (Glassmorphism Outline) */}
            <button 
              onClick={() => window.open('https://wa.me/919096785868?text=Hi! I want to contact the MICE team.', '_blank')}
              style={{
                padding: "14px 32px",
                borderRadius: "50px",
                fontWeight: "700",
                fontSize: "1rem",
                cursor: "pointer",
                border: "2px solid rgba(255, 255, 255, 0.8)",
                background: "rgba(255, 255, 255, 0.1)",
                backdropFilter: "blur(10px)",
                color: "white",
                transition: "all 0.3s",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
              }}
            >
              📞 Contact MICE Team
            </button>
          </div>
        </div>
      </section>

      {/* Industries We Serve Section */}
      <section className="hotel-partners-section">
        <div className="section-container">
          <h2 className="section-title-main">Industries We Serve</h2>
          <p className="section-subtitle">We specialize in organizing MICE events for a wide range of corporate sectors.</p>
          <div className="partners-grid">
            {industriesWeServe.map((industry, idx) => (
              <div className="partner-card" key={idx}>
                <div className="partner-logo">{industry.logo}</div>
                <h4>{industry.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our MICE Services Section */}
      <section className="hotel-categories-section">
        <div className="section-container">
          <h2 className="section-title-main">Our MICE Services</h2>
          <p className="section-subtitle">Comprehensive event management solutions tailored to elevate your corporate gatherings.</p>
          <div className="categories-grid">
            {miceServices.map((service, idx) => (
              <div className="category-card" key={idx}>
                <div className="category-icon">{service.icon}</div>
                <h3>{service.name}</h3>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-book-hotels-section">
        <div className="section-container">
          <h2 className="section-title-main">Why Choose Us?</h2>
          <div className="why-book-grid">
            {whyChooseBenefits.map((benefit, idx) => (
              <div className="why-book-item" key={idx}>
                <span className="benefit-icon-large">{benefit.icon}</span>
                <div className="benefit-content">
                  <h4>{benefit.title}</h4>
                  <p>{benefit.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Enquiry Form Section */}
      <section className="hotels-enquiry-section" id="mice-form">
        <div className="hotels-enquiry-container">
          
          {/* Left Side: Info */}
          <div className="hotels-info-panel">
            <h2>Ready to Plan Your Event?</h2>
            <ul className="hotels-benefits">
              <li>
                <span className="benefit-icon">📋</span>
                <div>
                  <strong>Free Consultation</strong>
                  <p>Get expert advice tailored to your corporate needs.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">💰</span>
                <div>
                  <strong>Best Corporate Rates</strong>
                  <p>Access exclusive deals and competitive pricing.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🌍</span>
                <div>
                  <strong>Global Network</strong>
                  <p>Worldwide destinations and venue options.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🎯</span>
                <div>
                  <strong>Customized Solutions</strong>
                  <p>Events designed to meet your specific objectives.</p>
                </div>
              </li>
            </ul>
            
            <div className="hotels-contact-direct">
              <p>Need immediate assistance?</p>
              <a href="tel:+919096785868" className="direct-phone">📞 +91 9096785868</a>
            </div>
          </div>

          {/* Right Side: Enquiry Form */}
          <div className="hotels-form-panel">
            <h3>MICE Enquiry Form</h3>
            <p className="form-subtitle">Tell us about your corporate event, and our specialists will craft a customized proposal within 24 hours.</p>

            <form className="hotels-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label>Your Name *</label>
                  <input type="text" name="name" placeholder="John Doe" value={form.name} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Phone Number *</label>
                  <input type="tel" name="phone" placeholder="+91 98765 43210" value={form.phone} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Email Address *</label>
                  <input type="email" name="email" placeholder="you@company.com" value={form.email} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>Company / Organization Name *</label>
                  <input type="text" name="companyName" placeholder="e.g., ABC Corp" value={form.companyName} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Event Type *</label>
                  <select name="eventType" value={form.eventType} onChange={handleChange} required>
                    <option value="Meeting">Business Meeting</option>
                    <option value="Incentive">Incentive Travel</option>
                    <option value="Conference">Conference / Seminar</option>
                    <option value="Exhibition">Exhibition / Trade Show</option>
                    <option value="Team Building">Team Building / Offsite</option>
                  </select>
                </div>
                <div className="form-field">
                  <label>Destination City *</label>
                  <input type="text" name="destination" placeholder="e.g., Goa, Singapore, Dubai" value={form.destination} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Start Date *</label>
                  <input type="date" name="startDate" value={form.startDate} onChange={handleChange} required />
                </div>
                <div className="form-field">
                  <label>End Date *</label>
                  <input type="date" name="endDate" value={form.endDate} onChange={handleChange} required />
                </div>
              </div>

              <div className="form-field">
                <label>Expected Number of Attendees *</label>
                <select name="attendees" value={form.attendees} onChange={handleChange} required>
                  <option value="10-25">10 - 25 People</option>
                  <option value="26-50">26 - 50 People</option>
                  <option value="51-100">51 - 100 People</option>
                  <option value="101-250">101 - 250 People</option>
                  <option value="250+">250+ People</option>
                </select>
              </div>

              <div className="form-field">
                <label>Special Requirements (Optional)</label>
                <textarea name="requirements" rows="4" placeholder="e.g., Need a 5-star resort with a large banquet hall, specific AV equipment, team-building activities, airport transfers, etc." value={form.requirements} onChange={handleChange}></textarea>
              </div>

              {status === "success" && (
                <div className="form-status success">
                  ✅ Enquiry sent successfully! Our MICE specialist will contact you shortly.
                </div>
              )}
              {status === "error" && (
                <div className="form-status error">
                  ⚠️ Something went wrong. Please try again or WhatsApp us directly.
                </div>
              )}

              <button type="submit" className="submit-enquiry-btn" disabled={status === "sending"}>
                {status === "sending" ? <span className="btn-spinner"></span> : "Submit MICE Enquiry"}
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MICE;